import _ from 'lodash';

// ToDo The legend building code should be moved to the backend

// This function to be made legacy
export const formatColours = (unformattedColours, systemName, type) => {
    if (typeof unformattedColours === 'string') {
        return { systemName: unformattedColours };
    } else if (Array.isArray(unformattedColours)) {
        if (unformattedColours.filter(colour => Array.isArray(colour))[0]) {
            unformattedColours.splice(0, 1);
            unformattedColours = unformattedColours.filter(colour => !Array.isArray(colour));
        }
        let colours = [];
        for (let i = 0; i < unformattedColours.length - 1; i += 2) {
            colours.push({ type: type, color: unformattedColours[i + 1], name: unformattedColours[i] });
        }
        // HERE
        if (unformattedColours[unformattedColours.length - 1] === 'rgba(255,255,255,0.1)') {
            colours.push({ type: type, color: 'rgba(255,255,255,0.1)', name: 'Other' });
        }
        return colours;
    }
};

const matchColors = (colorArray, key, other = {}) => {
    const groupKey = key + '-group';
    const groupCollectionKey = key + 's';
    // Needs expression, input, fallback and at least one label and output for match
    if (colorArray.length < 5) { return null; }
    let idx = 2;
    // If less than 7 then there is only a single match so don't use the group
    if (colorArray.length < 7) {
        return {
            type: key + '-row',
            label: colorArray[idx],
            color: colorArray[idx + 1],
            ...other
        };
    }
    // Otherwise there is multiple colors so use a group
    const spec = {
        type: groupKey,
        [groupCollectionKey]: []
    };
    for (;idx < colorArray.length - 1; idx+=2) {
        spec[groupCollectionKey].push({
            label: colorArray[idx],
            color: colorArray[idx + 1],
            ...other
        });
    }
    return spec;
};

const interpolateColors = (colorArray, other = {}) => {
    // Needs expression, interpolation, input, at least two stop_input2 and stop_ouputs2
    if (colorArray.length < 7) { return null; }
    let idx = 3;
    const spec = {
        type: 'range-divided',
        colors: [],
        labels: []
    };
    for (;idx < colorArray.length; idx+=2) {
        spec.labels.push(colorArray[idx]);
        spec.colors.push(colorArray[idx + 1]);
    }
    return spec;
};

const formatColor = (key, colorField, fallbackLabel, other = {}) => {
    if (Array.isArray(colorField)) {
        if (colorField.length === 0) { return null; }
        if (colorField[0] === 'match') {
            const spec = matchColors(colorField, key, other);
            return spec ? [spec] : null;
        } else if (colorField[0] === 'interpolate') {
            const spec = interpolateColors(colorField, other);
            return spec ? [spec] : null;
        }
        return null;
    } else {
        return [{
            type: key + '-row',
            label: fallbackLabel,
            color: colorField,
            ...other
        }];
    }
};

const SVGsLocation = '/mapbox/sprites/svgs';
export function buildLegendSpecification (style, name, system_name) {

    // Somewhere in this code, the mapvox style specification loses the first item in an array (by reference) which breaks a ton
    // This deep clone is a dirty quick fix to ensure we don't change the wrong thing.
    const layers = _.cloneDeep(style.mapboxStyleSpecification.layers);

    const index = 0;
    const paint = layers[index].paint;
    const other = {};

    // Should do on layer type as more accurate at gettign whether polygon, line or point

    switch (layers[index].type) {
        case 'fill':
            let fc = paint['fill-color'];
            let foc = paint['fill-outline-color'];
            let fo = paint['fill-opacity'];

            // Loop through other layers, if any are line then try extract a border
            for (let i = index + 1; i < layers.length; i++) {
                if (layers[index + 1].type === 'line') {
                    const linePaint = layers[i].paint;
                    // If has blur then probably a shadow not a border
                    if (linePaint['line-blur']) { continue; }
                    if (linePaint['line-color'] && !Array.isArray(linePaint['line-color'])) { other.borderColor = linePaint['line-color']; }
                    if (linePaint['line-width'] && !Array.isArray(linePaint['line-width'])) { other.borderWidth = linePaint['line-width']; }
                }
            }
            // Try use stroke for border if none found for line
            if (foc && !Array.isArray(foc) && !other.borderColor && !other.borderWidth) {
                other.borderColor = foc;
                other.borderWidth = 1;
            }

            if (fc) {
                const temp = formatColor('fill', fc, name, other);
                if (temp) { return temp; }
            }

            let styles = {};
            if (fc) {
                if (Array.isArray(fc)) {
                    // TODO: style mapbox "interpolate", etc.
                    return formatColours(fc, system_name, 'fill');
                }
                styles.backgroundColor = fc;
            }
            if (foc) {
                styles.border = '1.5px solid ' + foc;
                styles.boxSizing = 'border-box';
            }
            if (fo) {
                styles.opacity = fo;
            }
            if (layers[index].paint['fill-pattern']) {
                return [{ type: 'img', path: `${SVGsLocation}/${layers[index].paint['fill-pattern']}.svg`, name: name }];
            } else {
                return [{ type: 'fill', color: layers[index].paint['fill-pattern'], name: name, styles: styles }];
            }
        case 'circle':
            let circleColours = paint['circle-color'];
            let cr = paint['circle-radius'];
            let csc = paint['circle-stroke-color'];
            let csw = paint['circle-stroke-width'];

            if (lw && !Array.isArray(lw)) {
                other.radius = cr;
            }

            // Loop through other layers, if any are line then try extract a border
            for (let i = index + 1; i < layers.length; i++) {
                if (layers[index + 1].type === 'line') {
                    const linePaint = layers[i].paint;
                    // If has blur then probably a shadow not a border
                    if (linePaint['line-blur']) { continue; }
                    if (linePaint['line-color'] && !Array.isArray(linePaint['line-color'])) { other.borderColor = linePaint['line-color']; }
                    if (linePaint['line-width'] && !Array.isArray(linePaint['line-width'])) { other.borderWidth = linePaint['line-width']; }
                }
            }
            // Try use stroke for border if none found for line
            if (!other.borderColor && !other.borderWidth) {
                if (csc && !Array.isArray(csc)) {
                    other.borderColor = csc;
                }
                if (csw && !Array.isArray(csw)) {
                    other.borderWidth = csw;
                }
            }


            if (circleColours) {
                const temp = formatColor('circle', circleColours, name, other);
                if (temp) { return temp; }
            }

            // stops is legacy mapbox styling an should be removed
            if (circleColours && circleColours.stops) {
                let stops = [];
                for (let i = 0; i < circleColours.stops.length; i++) {
                    stops = [...stops, ...circleColours.stops[i]];
                }
                return formatColours(stops, system_name, 'circle');
            } else {
                if (Array.isArray(circleColours) && circleColours.filter(colour => Array.isArray(colour))[0]) {
                    circleColours.splice(0, 1);
                    circleColours = circleColours.filter(colour => !Array.isArray(colour));
                    return formatColours(circleColours, system_name, 'circle');
                } else if (typeof circleColours === 'string') {
                    return [{ type: 'circle', color: circleColours, name: name }];
                }
            }
        case 'line':
            let lc = layers[index].paint['line-color'];
            let lw = layers[index].paint['line-width'];

            if (lw && !Array.isArray(lw)) {
                other.width = lw;
            }

            if (lc) {
                const temp = formatColor('line', lc, name, other);
                if (temp) { return temp; }
            }

            let lp = layers[index].paint['line-pattern'];
            let lo = layers[index].paint['line-opacity'];
            if (lp) {
                let styles = {};
                if (lo) {
                    styles.opacity = lo;
                }
                return [{ type: 'img', path: `${SVGsLocation}/${lp}.svg`, name: name }];
            } else {
                return [{ type: 'line', color: layers[index].paint['line-color'], name: name, styles: styles }];
            }
        case 'symbol':
            const sprite = layers[index].layout['icon-image'];
            if (typeof(sprite) === 'string') {
                return [{ type: 'img', path: `${SVGsLocation}/${sprite}.svg`, name: name }];
            }
        case 'fill-extrusion':
            return [{ type: 'fill', color: layers[index].paint['fill-extrusion-color'], name: name }];
        case 'raster':
            return [{ type: 'raster', color: '#aaa', content: 'R', name: name }];
        default:
            return [];
            // console.log('Unidentified type:', layers[index].type)
    }
}